if (!customElements.get('paint-finder')) {
    class PaintFinder extends HTMLElement {
        constructor() {
            super();
            this.paintContainerEl = this.querySelector('[data-paint-container]');
            this.backgroudContainerEl = this.querySelector('[data-background]');
            this.imageSelectorEl = this.querySelector('[data-image-selector]');
            this.variantContainerEl = this.querySelector('[data-variant-container]');
            this.brandSelectorEl = this.querySelector('[data-brand-selector]');
            this.colorFilterEl = this.querySelector('[data-color-filter]');
            this.colorCountEl = this.querySelector('[data-color-count]');
            this.clearSelectionEl = this.querySelector('[data-deselect-all]');
            this.selectedContainerEl = this.querySelector('[data-selected-container]');

            this.colorSelectedTemplate = this.querySelector('[data-color-template]');
            this.colorVariantTemplate = this.querySelector('[data-variant-template]');

            this.activeImage = this.querySelector('.paint-image:not(.hidden)');

            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

            try {
                this.selectedColors = JSON.parse(localStorage.getItem('paint-finder-selected-colors')) || [];
            } catch (error) {
                this.selectedColors = [];
            }

            this.brands = [];

            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }

        async init() {
            const colorDataEl = this.querySelector('script[type="application/json"]');
            try {
                this.colorData = JSON.parse(colorDataEl.textContent);
            } catch (error) {
                return console.log('Color data failed to parse:', colorDataEl);
            }

            //Handling color data
            this.restructureColorData();
            await this.populateColorData();
            this.getColorCategories();
            this.filterAndSortColors();

            //DOM interactions
            this.addColorSwatchEls();
            this.createBrandOptionEls();

            this.registerEventListeners();
        }

        registerEventListeners() {
            this.imageSelectorEl.addEventListener('click', (e) => {
                if (e.target.matches('[data-block-id]')) {
                    this.activeImage.classList.add('hide-image');
                    this.activeImage = document.getElementById(e.target.dataset.blockId);
                    this.activeImage.classList.remove('hide-image');
                }
            });

            this.paintContainerEl.addEventListener('click', (e) => {
                if (e.target.matches('[data-color-handle]')) {
                    this.toggleColor(e.target.dataset.colorHandle);
                }
            });

            this.variantContainerEl.addEventListener('click', (e) => {
                if (e.target.matches('[data-toggle-visible-color]')) {
                    return this.toggleVisibleVariants(e);
                }

                if (e.target.matches('[data-variant-id]')) {
                    this.handleAddToCartClick(e);
                }

                if (e.target.matches('[data-remove-color]')) {
                    console.log('removing color', e.target.dataset.removeColor);
                    this.removeColor(e.target.dataset.removeColor);
                }
            });

            this.brandSelectorEl.addEventListener('change', (e) => {
                this.showBrand(e.target.value);
            });

            this.colorFilterEl.addEventListener('click', (e) => {
                if (e.target.matches('[data-color-category]')) {
                    this.showColorCategory(e.target.dataset.colorCategory);
                }
            });

            this.clearSelectionEl.addEventListener('click', this.clearSelectedColors.bind(this));
        }

        handleAddToCartClick(e) {
            const variantId = e.target.dataset.variantId;

            e.target.classList.add('loading');

            this.addVariantToCart(variantId)
                .catch((error) => {
                    console.error(error);

                    e.target.setAttribute('aria-disabled', true);

                    e.target.classList.add('disabled');
                })
                .finally(() => {
                    e.target.classList.remove('loading');
                });
        }

        toggleColor(handle) {
            const selectedColor = this.selectedColors.find((colorObj) => colorObj.handle === handle);
            if (selectedColor) {
                return this.removeColor(handle);
            }

            this.selectColor(handle);
        }

        selectColor(handle) {
            const colorObj = this.colors.find((color) => color.handle === handle);

            const el = document.createElement('div');
            el.classList.add('selected-color');

            el.dataset.colorHandle = handle;

            el.style.backgroundColor = colorObj.color.hexString;

            this.backgroudContainerEl.append(el);

            this.paintContainerEl.querySelector(`[data-color-handle="${handle}"]`).classList.add('selected');

            this.selectedColors.push(colorObj);

            this.selectedColors = this.selectedColors;

            this.createColorObjectEl(colorObj);

            this.createVariantEls(colorObj);

            this.updateColorCount();
        }

        removeColor(handle) {
            const colorIndex = this.selectedColors.findIndex((color) => color.handle === handle);
            const colorObj = this.selectedColors[colorIndex];

            if (!colorObj) throw new Error("Can't find colorobject in selected colors");

            const selector = `[data-color-handle="${handle}"]`;

            this.backgroudContainerEl.querySelector(selector).remove();

            this.paintContainerEl.querySelector(selector).classList.remove('selected');
            this.selectedColors.splice(colorIndex, 1);
            this.selectedColors = this.selectedColors;

            this.variantContainerEl.querySelectorAll(selector).forEach((el) => el.remove());

            this.updateColorCount();
        }

        updateColorCount() {
            const colorCount = this.selectedColors.length;
            this.colorCountEl.textContent = `(${colorCount})`;

            this.selectedContainerEl.classList.toggle('hidden', colorCount === 0);
        }

        clearSelectedColors() {
            [...this.selectedColors].forEach((color) => this.removeColor(color.handle));
        }

        showBrand(handle) {
            this.selectedBrand = handle;
            this.paintContainerEl.querySelectorAll(`.color-swatch`).forEach((el) => {
                const visible = handle === 'ALL' ? true : el.hasAttribute(`data-brand-${handle}`);

                el.classList.toggle('hidden', !visible);
            });
        }

        createBrandOptionEls() {
            this.brands.forEach((brand) => {
                const el = document.createElement('option');
                el.value = brand.handle;
                el.textContent = brand.name;
                this.brandSelectorEl.appendChild(el);
            });
        }

        createColorObjectEl(colorObj) {
            try {
                const el = Heltra.populateTemplate(this.colorSelectedTemplate, {
                    handle: colorObj.handle,
                    name: colorObj.name,
                    hexString: colorObj.color.hexString,
                    productCount: colorObj.variants.length
                });

                this.variantContainerEl.appendChild(el);
            } catch (error) {
                console.log("Couldn't add color object element: ", colorObj, error);
            }
        }

        createVariantEls(colorObj) {
            console.log(colorObj);
            colorObj.variants.forEach((variant) => {
                try {
                    const variantLink = variant.product_url + `?variant=${variant.id}`;

                    const imageSource = variant.featured_image?.src ? variant.featured_image.src : variant.product_image;

                    const el = Heltra.populateTemplate(this.colorVariantTemplate, {
                        handle: colorObj.handle,
                        name: colorObj.name,
                        hexString: colorObj.color.hexString,
                        imageSource,
                        variantLink,
                        money: this.getMoneyHTML(variant),
                        productTitle: variant.product_title,
                        variantId: variant.id
                    });

                    this.variantContainerEl.appendChild(el);
                } catch (error) {
                    console.log("Couldn't add variant: ", variant, error);
                }
            });
        }

        getMoneyHTML(variant) {
            if (variant.price >= variant.compare_at_price || variant.compare_at_price === 0) {
                return `<span class="color-variant__price">${Heltra.formatMoney(variant.price)}</span>`;
            }

            return `<span class="color-variant__price">${Heltra.formatMoney(variant.price)}
                    <span class="color-variant__price_compare">
                        ${Heltra.formatMoney(variant.compare_at_price)}
                    </span>         
                </span>`;
        }

        addColorSwatchEls() {
            const fragment = document.createDocumentFragment();

            Object.entries(this.colorClusters).forEach(([key, cluster]) => {
                /* const div = document.createElement('div');
            const el = document.createElement('h4');
            el.textContent = key;
            div.appendChild(el); */

                this.addColorFilterOptionEl(key);

                cluster.forEach((colorObj) => {
                    fragment.appendChild(this.createColorSwatchEl(colorObj));
                });

                //fragment.appendChild(div);
            });

            this.paintContainerEl.appendChild(fragment);
        }

        addColorFilterOptionEl(category) {
            const el = document.createElement('div');

            el.classList.add('color-filter-option');

            el.textContent = category;

            el.dataset.colorCategory = category;

            this.colorFilterEl.appendChild(el);
        }

        createColorSwatchEl(colorObj) {
            const el = document.createElement('div');
            el.classList.add('color-swatch');
            if (colorObj.color.invertUi) {
                el.classList.add('invert-ui');
            }

            //el.textContent = `${colorObj.name} (${colorObj.color.hsl})`;

            colorObj.variants.forEach((variant) => el.setAttribute(`data-brand-${variant.brandHandle}`, ''));

            el.dataset.colorCategory = colorObj.color.category;
            el.dataset.colorHandle = colorObj.handle;
            el.dataset.name = colorObj.name;
            el.dataset.colorHsl = colorObj.color.hsl;

            el.style.backgroundColor = colorObj.color.hexString;

            /* 
        const noteEl = document.createElement('span');
        noteEl.classList.add('color-swatch-label');
        noteEl.textContent = colorObj.name;

        el.appendChild(noteEl);
        */

            try {
                tippy(el, {
                    content: colorObj.name
                });
            } catch (error) {
                console.error(error);
            }

            return el;
        }

        showColorCategory(category) {
            const paintSwatchEls = this.paintContainerEl.querySelectorAll('.color-swatch');

            paintSwatchEls.forEach((el) => {
                el.classList.toggle('dampen-opacity', el.dataset.colorCategory !== category);
            });

            const firstOfCategoryEl = this.paintContainerEl.querySelector(`.color-swatch[data-color-category="${category}"]`);

            this.paintContainerEl.scrollTo({
                left: firstOfCategoryEl.offsetLeft - this.paintContainerEl.offsetLeft,
                behavior: 'smooth'
            });

            setTimeout(() => {
                //check if function has been run again for a diff cateogry (then we don't want to do anything here)
                if (firstOfCategoryEl.classList.contains('dampen-opacity')) return;
                paintSwatchEls.forEach((el) => {
                    el.classList.remove('dampen-opacity');
                });
            }, 3000);
        }

        toggleVisibleVariants(e) {
            const handle = e.target.dataset.toggleVisibleColor;
            const variantEls = this.variantContainerEl.querySelectorAll(`.color-variant[data-color-handle="${handle}"]`);

            const visible = variantEls[0].classList.contains('hidden');

            if (visible) {
                e.target.innerHTML = e.target.innerHTML.replace('Show', 'Hide');
            } else {
                e.target.innerHTML = e.target.innerHTML.replace('Hide', 'Show');
            }

            e.target.toggleAttribute('open', visible);

            variantEls.forEach((el) => el.classList.toggle('hidden', !visible));
        }

        async addVariantToCart(variantId) {
            const fetchBody = {
                items: [
                    {
                        id: variantId,
                        quantity: 1
                    }
                ]
            };

            if (this.cart) {
                fetchBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
                this.cart.setActiveElement(document.activeElement);
            }

            return fetch(routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(fetchBody)
            })
                .then((data) => data.json())
                .then((res) => {
                    if (res.status) {
                        const errorObj = { source: 'paint-finder', productVariantId: variantId, errors: res.description, message: res.message };
                        publish(PUB_SUB_EVENTS.cartError, errorObj);

                        throw new Error('Failed to add product:', errorObj);
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'paint-finder', productVariantId: variantId });

                    try {
                        if (this.cart) {
                            this.cart.renderContents(res);
                        }
                    } catch (error) {
                        console.warn("Cart drawer didn't updated correctly", error);
                    }

                    return res;
                });
        }

        filterAndSortColors() {
            this.colorClusters = this.colors.reduce((groups, colorObj) => {
                const key = colorObj.color.category;
                if (!groups[key]) {
                    groups[key] = [];
                }
                groups[key].push(colorObj);
                return groups;
            }, {});

            Object.values(this.colorClusters).forEach((cluster) => {
                cluster.sort((color1, color2) => color2.color.lightness - color1.color.lightness);
            });
        }

        async populateColorData() {
            const promises = this.colors.map((colorObj) => {
                try {
                    const variantWithColorMetafield = colorObj.variants.find((variant) => variant.variant_color);
                    if(variantWithColorMetafield){
                        const metafieldRGB = [...variantWithColorMetafield.variant_color].map(s => Number(s))

                        return (colorObj.color = Heltra.colorUtils.getColorObject(...metafieldRGB));
                    }

                    //If there's no metafield color, use the image

                    const variantSrc = colorObj.variants[0].featured_image.src + '&width=25';

                    return Heltra.colorUtils.getMiddlePixelColor(variantSrc).then((color) => {
                        colorObj.color = Heltra.colorUtils.getColorObject(...color);
                    });
                } catch (error) {
                    console.log(`Will not include "${colorObj.name}" (missing image):`, { error, variant: colorObj.variants[0], colorObj });
                    return Promise.resolve(); // Resolve the promise so that Promise.all doesn't fail
                }
            });
            return Promise.all(promises);
        }

        /**
         * Extracts brand name from product tags.
         * @param {Array} product_tags - The product tags.
         * @returns {Object} The brand name and handle.
         */
        extractBrandFromTags(product_tags) {
            const brandTag = product_tags.find((str) => str.startsWith('Brand-'));
            if (!brandTag) {
                throw new Error('No brand tag found. Product tags: ' + JSON.stringify(product_tags));
            }
            const brandName = brandTag.replace('Brand-', '');
            const brandHandle = brandName.toLowerCase().replace(' ', '-');
            return { brandName, brandHandle };
        }

        /**
         * Adds a new brand to the brands array if it doesn't exist.
         * @param {Object} brand - The brand to add.
         */
        addBrand(brand) {
            const brandExists = this.brands.some((existingBrand) => existingBrand.handle === brand.handle);
            if (!brandExists) {
                this.brands.push(brand);
            }
        }

        /**
         * Restructures the color data stored in `this.colorData` into a new format.
         */
        restructureColorData() {
            const colorGroups = this.colorData.reduce((groups, item) => {
                if (item.variant.available && item.variant.featured_image) {
                    const { handle, name, variant, product_tags, ...rest } = item;
                    try {
                        const { brandName, brandHandle } = this.extractBrandFromTags(product_tags);
                        this.addBrand({ handle: brandHandle, name: brandName });

                        const color = handle;
                        if (!groups[color]) {
                            groups[color] = { handle, name, variants: [] };
                        }
                        groups[color].variants.push({ ...variant, colorName: name, brandName, brandHandle, product_tags, ...rest });
                    } catch (error) {
                        console.error(error, item);
                    }
                }
                return groups;
            }, {});

            this.colors = Object.values(colorGroups);
        }

        /**
         * Gets the color of the middle pixel of an image.
         *
         * @param {string} imgUrl - The image URL.
         * @returns {Promise<Object>} A promise that resolves to a color object containing the color of the middle pixel
         */
        async getMiddlePixelColor(imageSource) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = imageSource;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const context = canvas.getContext('2d');
                    context.drawImage(img, 0, 0, img.width, img.height);
                    const middleX = Math.floor(img.width / 2);
                    const middleY = Math.floor(img.height / 2);
                    const [r, g, b] = context.getImageData(middleX, middleY, 1, 1).data;
                    const hexString = this.rgbToHex(r, g, b);
                    const [hue, saturation, lightness] = this.rgbToHsl(r, g, b);

                    resolve({
                        r,
                        g,
                        b,
                        rgb: [r, g, b],
                        hexString,
                        hsl: [hue, saturation, lightness],
                        hue,
                        saturation,
                        lightness,
                        invertUi: lightness < 50
                        /* ,
                    category: this.getColorCategory(...this.rgbToHsl(r, g, b)) */
                    });
                };
                img.onerror = reject;
            });
        }

        getColorCategories() {
            this.colors.forEach((colorObj) => {
                colorObj.color.category = this.getColorCategory(colorObj);
            });
        }

        getColorCategory(colorObj) {
            return this.getColorCategoryFromString(colorObj.name) || this.getColorCategoryFromHSL(...colorObj.color.hsl);
        }

        getColorCategoryFromHSL(h, s, l) {
            if (l < 5 || (l < 10 && s < 10)) {
                return 'BLACKS';
            } else if (l > 98 || (l > 96 && s < 8)) {
                return ' WHITES';
            } else if (h >= 0 && h < 30) {
                return l < 50 ? 'BROWNS' : 'REDS'; // consider a color as 'BROWNS' if lightness is low
            } else if (h >= 30 && h < 45) {
                return l < 50 ? 'BROWNS' : 'BROWNS';
            } else if (h >= 45 && h < 60) {
                return 'YELLOWS';
            } else if (h >= 60 && h < 150) {
                return 'GREENS';
            } else if (h >= 150 && h < 240) {
                return 'BLUES';
            } else if (h >= 240 && h < 300) {
                return 'PURPLES';
            } else if (h >= 300 && h <= 360) {
                return 'REDS';
            } else {
                return 'NEUTRALS';
            }
        }

        getColorCategoryFromString(string) {
            const lowerCaseString = string.toLowerCase();
            const categories = [
                {
                    name: 'BROWNS',
                    colors: ['brown', 'sandstone', 'copper', 'tan', 'beige', 'chestnut', 'hazel', 'coffee', 'chocolate', 'mahogany', 'walnut', 'sand', 'almond']
                },
                {
                    name: 'REDS',
                    colors: ['red', 'crimson', 'scarlet', 'ruby', 'cherry', 'garnet', 'vermilion', 'rose', 'brick', 'autumn']
                },
                {
                    name: 'ORANGES',
                    colors: ['orange', 'tangerine', 'peach', 'apricot', 'amber', 'coral', 'salmon', 'carrot', 'pumpkin', 'marigold']
                },
                {
                    name: 'YELLOWS',
                    colors: ['yellow', 'gold', 'lemon', 'banana', 'pineapple', 'maize', 'butter', 'daffodil', 'canary', 'sunflower']
                },
                {
                    name: 'GREENS',
                    colors: ['green', 'lime', 'olive', 'jade', 'emerald', 'pear', 'mint', 'fern', 'forest', 'grass', 'apple', 'pistachio']
                },
                {
                    name: 'BLUES',
                    colors: ['blue', 'navy', 'sky', 'ocean', 'sapphire', 'azure', 'teal', 'turquoise', 'indigo', 'cobalt']
                },
                {
                    name: 'PURPLES',
                    colors: ['purple', 'violet', 'lavender', 'plum', 'magenta', 'lilac', 'grape', 'eggplant', 'orchid', 'amethyst']
                },
                {
                    name: 'WHITES',
                    colors: ['white', 'silver', 'ivory', 'morning light', 'snow', 'alabaster', 'seashell']
                },
                {
                    name: 'GREYS',
                    colors: ['gray', 'grey', 'equinox', 'gainsboro', 'silver', 'rock']
                },
                {
                    name: 'BLACKS',
                    colors: ['black', 'gray', 'charcoal', 'ash', 'slate', 'iron', 'smoke', 'onyx', 'obsidian', 'jet']
                }
            ];

            for (let category of categories) {
                for (let color of category.colors) {
                    if (lowerCaseString.includes(color)) {
                        return category.name;
                    }
                }
            }
        }
    }

    customElements.define('paint-finder', PaintFinder);
}
